import { AlertTriangle, CheckCircle2, Clock3, ShieldAlert } from "lucide-react";


const statusMap = {
  ready: { label: "Ready", className: "border-emerald-500/30 bg-emerald-500/10 text-emerald-300", Icon: CheckCircle2 },
  pending_dns: { label: "DNS pending", className: "border-amber-500/30 bg-amber-500/10 text-amber-300", Icon: Clock3 },
  ssl_issue: { label: "SSL issue", className: "border-rose-500/30 bg-rose-500/10 text-rose-300", Icon: ShieldAlert },
  flagged: { label: "Unavailable", className: "border-rose-500/30 bg-rose-500/10 text-rose-300", Icon: AlertTriangle },
  not_routable: { label: "Not routable", className: "border-slate-500/30 bg-slate-700/20 text-slate-300", Icon: AlertTriangle },
  old: { label: "Previously used", className: "border-slate-600 bg-slate-800 text-slate-300", Icon: Clock3 },
};


export const DomainStatusBadge = ({ domain, status, label }) => {
  const config = statusMap[status] || statusMap.pending_dns;
  const Icon = config.Icon;
  return (
    <span className={`inline-flex items-center gap-1 rounded-md border px-2 py-1 text-[11px] font-medium ${config.className}`} data-testid={`domain-status-${domain.id || domain.domain}-${status}`}>
      <Icon className="h-3 w-3" />
      {label || config.label}
    </span>
  );
};